import { prop } from 'ramda';
import { urls } from '../../config.js';
import getParams from '../../utils/getParams';
import { translateHugggPaginatedResponse } from '../../utils/huggg';

/**
 * Fetch all hugggs by a given transaction ID, with optional query parameters.
 * Data is translated into camelCase before being returned.
 *
 * Any embedded data is stripped before sending. Although the API endpoint does
 * support it, it returns too much data in this instance.
 *
 * huggg.allBySuperhugggId(axios, superhugggId).then( ... )
 * huggg.allBySuperhugggId(superhugggId).then( ... )
 * huggg.allBySuperhugggId(superhugggId, {page: 2, perPage: 40}).then( ... )
 *
 * @param {Object} [axios=axios] Axios instance.
 * @param {String} superhugggId
 * @param {Object} [options={}] Query string parameter options.
 * @param {Number} [options.page=1] Which page of data to fetch.
 * @param {Number} [options.perPage=20] How many results per page to fetch.
 * @returns {Promise} Unresolved promise.
 * @throws {Error} If no superhugggId is supplied.
 */
var allBySuperhugggId = function allBySuperhugggId(axios, superhugggId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!superhugggId) {
    throw new Error('Prop `superhugggId` is required in `huggg.allBySuperhugggId`');
  }
  if (options.embed) {
    delete options.embed;
  }
  var defaultParams = {
    per_page: 20,
    page: 1
  };
  var params = getParams(options, defaultParams, {
    sortColumnMap: {
      expires: 'expires',
      status: 'status'
    }
  });
  return axios.get(urls.apiV2("/super-hugggs/".concat(superhugggId, "/hugggs")), {
    params: params
  }).then(prop('data')).then(translateHugggPaginatedResponse);
};
export default allBySuperhugggId;